import React, { useState, useEffect } from 'react';
import { ButtonComponent, CustomDatePicker, Studentdatetime ,TimePickerModal } from 'tutorapp-components';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {  setDate, setTime ,setDuration as setDurationAction } from '../redux/actions/familyPresetValuesActions';
import { BLACK_COLOR } from '../utils/theme';
import { createFamilyAppointment } from '../redux/actions/familyAppointmentActions';

export default function Studentdatetimescreen() {
  const moment = require('moment-timezone');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState({ start: "", end: "" });
  const [duration, setDuration] = useState("");

  const date = useSelector((state) => state.familyPresetValues.date);
  const time = useSelector((state) => state.familyPresetValues.time);
  const durationFromStore = useSelector((state) => state.familyPresetValues.duration);

  const userPreferences = useSelector((state) => state.userPreferences);

  // Duration options (15 min to 12 hours in 15-min increments)
  const durationOptions = Array.from({ length: 48 }, (_, i) => {
    const totalMinutes = (i + 1) * 15;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const label =
      hours > 0
        ? `${hours} hour${hours > 1 ? 's' : ''}${minutes > 0 ? ` ${minutes} min${minutes > 1 ? 's' : ''}` : ''}`
        : `${minutes} mins`;
    return { value: totalMinutes, label };
  });

  const formatTime = (time) => {
    return time ? `${time}:00` : '';
  };

  const formatDate = (date) => {
    const d = new Date(date);
    return d.toISOString().split('T')[0];
  };

  // Calculate end time based on start time and duration
  const calculateEndTime = (startTime, durationMinutes) => {
    if (!startTime || !durationMinutes) return '';
    const match = startTime.match(/^(\d{2}:\d{2})$/);
    if (!match) return '';

    const start = moment(startTime, 'HH:mm');
    const end = start.clone().add(durationMinutes, 'minutes');
    return end.format('HH:mm');
  };

  const handleTimeSelection = (time) => {
    const newTime = {
      start: time,
      end: calculateEndTime(time, duration)
    };
    setSelectedTime(newTime);
  };

  const handleDurationChange = (e) => {
    const newDuration = Number(e.target.value);
    setDuration(newDuration);
    if (selectedTime.start) {
      const newEndTime = calculateEndTime(selectedTime.start, newDuration);
      setSelectedTime({ ...selectedTime, end: newEndTime });
    }
  };

  const handleContinue = () => {
    const datetime = {
      appointment_start_time: formatTime(selectedTime.start),
      appointment_date: formatDate(selectedDate),
      appointment_end_time: formatTime(selectedTime.end)
    };
    dispatch(createFamilyAppointment(datetime));
    dispatch(setDate(selectedDate));
    dispatch(setTime(selectedTime));
    dispatch(setDurationAction(duration));

    navigate('/student-setup');
  };

  const handleBack = () => {
    navigate('/filldetails');
  };

  const handleSelectionClose = () => {
    navigate("/MyAppointment");
  };

  useEffect(() => {
    if (date) {
      setSelectedDate(date);
    }

    if (time) {
      setSelectedTime({
        start: time.start,
        end: time.end
      });
    }
     if (durationFromStore) {
    setDuration(durationFromStore);
    if (time?.start) {
      const newEndTime = calculateEndTime(time.start, durationFromStore);
      setSelectedTime({ start: time.start, end: newEndTime });
    }
  }

  }, [date, durationFromStore]);

  // Check if all required values are selected
  const isContinueDisabled = !selectedDate || !selectedTime.start || !selectedTime.end || !duration;

  return (
    <div>
      <Studentdatetime icons={{
        backarrow: './images/ic_back.svg',
        address: './images/ic_tutoring_address.svg',
        repeat: './images/ic_repeat.svg',
        sessionappointment: './images/ic_sessionappointment.svg',
        close: './images/ic_close.svg',
        progress: './images/ic_3.svg',
      }} handleselectionclose={handleSelectionClose} />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginBottom: '5px',
          fontFamily: 'GT-Walsheim',
        }}
      >
        <div className="mb-2 mt-3" style={{ width: '325px' }}>
          <label
            className="d-block text-start mb-2"
            style={{ fontSize: 15, color: '#0b1422', fontFamily: 'GT-Walsheim-Medium' }}
          >
            Start Date
          </label>
          <CustomDatePicker
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            userPreferences={userPreferences}
          />
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginBottom: '25px',
          fontFamily: 'GT-Walsheim',
        }}
      >
        <div className="mb-2" style={{ width: '325px', fontFamily: 'GT-Walsheim' }}>
          <label
            className="d-block text-start mb-2"
            style={{ fontSize: 15, color: '#0b1422', fontFamily: 'GT-Walsheim-Medium' }}
          >
            Start Time
          </label>
          <TimePickerModal
            onTimeSelect={handleTimeSelection}
            defaultStartTime={selectedTime.start}
            userPreferences={userPreferences}
           
          />
        </div>
        <div className="mb-2" style={{ width: '325px', fontFamily: 'GT-Walsheim' }}>
  <label
    className="d-block text-start mb-2"
    style={{ fontSize: 15, color: '#0b1422', fontFamily: 'GT-Walsheim-Medium' }}
  >
    Duration
  </label>
  {durationFromStore ? (
    <select
      value={ duration ? duration : durationFromStore }
      onChange={handleDurationChange}
      className="form-control text-center"
      style={{ height: '45px', fontFamily: 'GT-Walsheim', color: 'black' }}
    >
      <option value="" disabled>
        Select duration
      </option>
      {durationOptions.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  ) : (
    <select
      value={duration}
      onChange={handleDurationChange}
      className="form-control text-center"
      style={{ height: '45px', fontFamily: 'GT-Walsheim', color: 'black' }}
    >
      <option value="" disabled>
        Select duration
      </option>
      {durationOptions.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  )}
</div>

        
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          fontFamily: 'GT-Walsheim',
          alignItems: 'center',
          marginTop: '55px',
        }}
      >
        <div style={{ width: '330px', marginBottom: 10 }}>
          <ButtonComponent
            onPress={isContinueDisabled ? null : handleContinue}
            label="Continue"
            disabled={isContinueDisabled}
            style={{
              backgroundColor: isContinueDisabled ? '#ccc' : BLACK_COLOR,
              paddingVertical: 12,
              fontFamily: 'GT-Walsheim',
              pointerEvents: isContinueDisabled ? 'none' : 'auto',
            }}
            textStyle={{
              color: isContinueDisabled ? '#666' : 'white',
              fontFamily: 'GT-Walsheim',
            }}
          />
        </div>

        <div style={{ width: '330px' }}>
          <ButtonComponent
            label="Back"
            onPress={handleBack}
            style={{ backgroundColor: '#E9EDF1', paddingVertical: 12, fontFamily: 'GT-Walsheim' }}
            textStyle={{ color: '#000', fontFamily: 'GT-Walsheim' }}
          />
        </div>
      </div>
    </div>
  );
}